@if ({ orderHistory: orders$ | async, replenishmentOrder: hasReplenishmentOrder$ | async }; as type) {
  @if (type.orderHistory) {
    <div [ngClass]="type.replenishmentOrder ? '' : 'container'">
      <!-- HEADER -->
      <div class="row header-container">
        <div class="col-12">
          <h1 class="page-title">
            @if (type.replenishmentOrder) {
              {{ 'orderHistory.replenishmentHistory' | cxTranslate }}
            }
            @if (!type.replenishmentOrder) {
              {{ 'orderHistory.orderHistory' | cxTranslate }}
            }
          </h1>
          <p class="description">{{ pageDescription }}</p>
        </div>
      </div>
      <!-- BODY -->
      <div class="cx-order-history-body">
        <!-- Select Form and Pagination Top -->
        @if (type.orderHistory?.pagination?.totalResults > 0 || appliedFilter;) {
          <div class="table-filter-header top row">
            <button class="btn btn-action btn-white" (click)="toggleAdvancedSearch()">
              <app-custom-icons [type]="iconTypes.SEARCH"></app-custom-icons>
              {{ 'common.filters.advancedSearch' | cxTranslate }}
            </button>
            @if (showAdvancedSearch) {
              <div class="col-12 filters">
                <form [formGroup]="filtersForm" class="w-100" @fadeIn @fadeOut>
                  <div class="row">
                    <div class="col">
                      <div class="formGroup">
                        <label>
                          <span class="label-content">{{ 'common.filters.status' | cxTranslate }}</span>
                          @if (getStatusList() | async; as statusList) {
                            <div>
                              <select formControlName="statuses" class="form-control filter-select">
                                <option selected value="">
                                  {{ 'common.select' | cxTranslate }}
                                </option>
                                @for (statusItem of statusList.items; track statusItem) {
                                  <option class="option-select"
                                    [value]="statusItem.code">
                                    {{ statusItem.name }}
                                  </option>
                                }
                              </select>
                              <!--                            <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>-->
                            </div>
                          }
                          <!--                          <ng-container *ngIf="getStatusList() | async as statusList">-->
                          <!--                            <ng-select-->
                          <!--                              formControlName="statuses"-->
                          <!--                              [searchable]="true"-->
                          <!--                              [clearable]="true"-->
                          <!--                              [closeOnSelect]="true"-->
                          <!--                              [items]="statusList.items"-->
                          <!--                              bindLabel="name"-->
                          <!--                              bindValue="code"-->
                          <!--                              placeholder="{{ 'common.filters.status' | cxTranslate}}"-->
                        <!--                            ></ng-select>-->
                      <!--                          </ng-container>-->
                    </label>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label>
                      <span class="label-content">{{ 'common.filters.orderNumber' | cxTranslate }}</span>
                      <input type="text" class="form-control" formControlName="orderRequest" />
                    </label>
                  </div>
                </div>
                <div class="col date">
                  <div class="form-group">
                    <label>
                      <span class="label-content">{{ 'common.filters.startDate' | cxTranslate }}</span>
                      <app-date-picker [control]="filtersForm.get('initDate')"
                        (update)="updateDatepicker('initDate')">
                      </app-date-picker>
                      <!--                          <app-custom-icons [type]="iconTypes.ICON_CALENDAR"></app-custom-icons>-->
                    </label>
                  </div>
                </div>
                <div class="col date">
                  <div class="form-group">
                    <label>
                      <span class="label-content">{{ 'common.filters.endDate' | cxTranslate }}</span>
                      <app-date-picker [control]="filtersForm.get('endDate')"
                        (update)="updateDatepicker('endDate')">
                      </app-date-picker>
                    </label>
                  </div>
                </div>
                <div class="col action">
                  <button class="btn btn-primary btn-black btn-with-icon" type="button" (click)="applyFilter()">
                    <app-custom-icons [type]="iconTypes.ICON_FILTRAR"></app-custom-icons>
                    {{ 'common.filters.filter' | cxTranslate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          @if (type.orderHistory?.pagination?.totalPages > 1) {
            <div class="cx-order-history-pagination">
              <cx-pagination [pagination]="type.orderHistory.pagination"
              (viewPageEvent)="pageChange($event)"></cx-pagination>
            </div>
          }
        }
      </div>
    }
    @if (type.orderHistory?.pagination?.totalResults > 0) {
      <!-- TABLE -->
      @for (order of type.orderHistory?.orders; track order) {
        <table id="table-history" class="table cx-order-history-table mb-3">
          <tbody class="w-100">
            <tr class="bg-grey-light"> <!--(click)="goToOrderDetail(order)"-->
              <td colspan="3" class="cx-order-history-code">
                <div class="cx-order-history-header justify-content-md-between">
                  <div class="cx-order-history-data cx-table-header-title">
                    <span class="cx-table-header-label">
                      {{ 'orderHistory.orderId' | cxTranslate }}
                    </span>
                    <span class="cx-order-history-value text-decoration-none">
                      &nbsp;{{ order?.customerOrderReference }}
                    </span>
                  </div>
                </div>
              </td>
              <td class="table-header-icon">
                <a class="help btn text-bold btn-with-icon"
                  [routerLink]="{ cxRoute: 'ticketsCode', params: { code: order?.customerOrderReference,mail: order?.customer?.contactEmail }} | cxUrl">
                  <app-custom-icons [type]="iconTypes.ICON_QUESTION"></app-custom-icons>
                  {{ 'orderHistory.actions.faq' | cxTranslate }}
                </a>
              </td>
              <td class="table-header-icon">
                <button type="button" (click)="repeatOrder(order?.customerOrderReference)"
                  class="repeat-order btn text-bold btn-with-icon">
                  <app-custom-icons [type]="iconTypes.ICON_REPEAT"></app-custom-icons>
                  {{ 'orderHistory.actions.repeatOrder' | cxTranslate }}
                </button>
              </td>
            </tr>
            <tr class="cx-order-history-table-info">
              <td class="cx-order-history-placed pl-md-3">
                <div class="cx-table-header-label">
                  {{ 'orderHistory.date' | cxTranslate }}
                </div>
                <span class="cx-order-history-value">
                  {{ order?.date | cxDate: 'shortDate' }}
                </span>
              </td>
              <td class="cx-order-history-status">
                <div class="cx-table-header-label">
                  {{ 'orderHistory.status' | cxTranslate }}
                </div>
                <span class="cx-order-history-value">
                  {{ 'orderDetails.statusDisplay_STATUS_' + order?.orderStatus | cxTranslate }}
                </span>
              </td>
              <td class="cx-order-history-amount">
                <div class="cx-table-header-label">
                  {{ 'orderHistory.amount' | cxTranslate }}
                </div>
                <span class="cx-order-history-value">
                  {{ order?.subTotal?.formattedValue }}
                </span>
              </td>
              <td class="cx-order-history-total">
                <div class="cx-table-header-label">
                  {{ 'orderHistory.total' | cxTranslate }}
                </div>
                <span class="cx-order-history-value">
                  {{ order?.totalOrder?.formattedValue }}
                </span>
              </td>
              <td class="cx-order-history-details">
                <div class="cx-table-header-label">
                  {{ 'orderHistory.details.header' | cxTranslate }}
                </div>
                <span class="cx-order-history-value underline pointer" (click)="loadOrderDetails(order.code)">
                  {{ (showOrderDetail && openOrderDetail === order.code ?
                  'orderHistory.details.value.hide' : 'orderHistory.details.value.show') | cxTranslate }}
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot class="" @fadeIn @fadeOut>
            @if (showOrderDetail && openOrderDetail === order.code) {
              <tr>
                <td colspan="5">
                  <app-custom-order-details class="col-12"></app-custom-order-details>
                </td>
              </tr>
              <tr>
                <td class="container-order-details-shipping" colspan="5">
                  <cx-order-details-shipping></cx-order-details-shipping>
                </td>
              </tr>
              <tr>
                <td class="container-order-details-totals" colspan="5">
                  <cx-order-details-totals></cx-order-details-totals>
                </td>
              </tr>
            }
          </tfoot>
        </table>
      }
      <!-- Select Form and Pagination Bottom -->
      <div class="cx-order-history-sort bottom row">
        @if (type.orderHistory?.pagination?.totalPages > 1) {
          <div class="cx-order-history-pagination">
            <cx-pagination [pagination]="type.orderHistory.pagination"
            (viewPageEvent)="pageChange($event)"></cx-pagination>
          </div>
        }
      </div>
    } @else {
      @if (isLoaded$ | async) {
<div [ngClass]="type.replenishmentOrder
                        ? 'cx-replenishment-details-order-history-no-order row' : 'cx-order-history-no-order row'">
          <div [ngClass]="type.replenishmentOrder ? '' : 'col-sm-12'">
            @if (type.replenishmentOrder) {
              <div>{{ 'orderHistory.notFound' | cxTranslate }}</div>
            } @else {
              @if (appliedFilter) {
                <h3>{{ 'orderHistory.noResultsFound' | cxTranslate }}</h3>
              } @else {
                <div class="order-history-no-orders">{{ 'orderHistory.noOrders' | cxTranslate }}</div>
                <a [routerLink]="{ cxRoute: 'home' } | cxUrl" routerLinkActive="active"
                  class="btn btn-primary btn-block">{{ 'orderHistory.startShopping' | cxTranslate }}
                </a>
              }
            }
          </div>
        </div>
      }
    }
    <!-- NO ORDER CONTAINER -->
  </div>
</div>
}
}
